export default __webpack_public_path__ + "static/media/pic-certificate.5b0b2321.svg";